import React from 'react';
import { Form } from 'react-bootstrap';
import { getEmail } from '../helpers/email';
import { Person } from '../types/form';

interface FormEmailProps {
  email: string | null;
  emailValid: boolean;
  person: Person;
  setEmail: (email: string | null) => void;
  setEmailValid: (emailValid: boolean) => void;
}

function FormEmail({ email, emailValid, person, setEmail, setEmailValid }: FormEmailProps) {
  return (
    <Form.Group className="mb-3" controlId="formEmail">
      <Form.Label>Służbowy adres e-mail:</Form.Label>
      <Form.Control type="email" value={email || ''} onChange={(event: any) => {
        setEmail(event.target.value || null);
        setEmailValid(event.target.validity.valid);
      }} placeholder={`np. ${getEmail(person)}`} isInvalid={(email && !emailValid) || false} />
    </Form.Group>
  );
}

export default FormEmail;
